import { Outlet, useNavigate, useParams } from "react-router-dom";
import useFlow from "../hooks/useFlow";
import { useEffect, useState } from "react";
import { clearHubSpotState } from "../utils/hubspot";
import RegisterModal from "./RegisterModal";
import TermsModal from "./TermsModal";
import PlansOfferModal from "./PlansOfferModal";
import PopularItemModal from "./PopularItemModal";
import FindClientModal from "./FindClientModal";
import NewCheckoutModal from "./NewCheckoutModal";
import CheckoutGiftcardModal from "./CheckoutGiftcardModal";
import EventDetailModal from "./EventDetailModal";
import MapResourceModal from "./MapResourceModal";
import ProductListModal from "./ProductListModal";
import EventNotificationModal from "./EventNotificationModal";
import AskPhoneModal from "./AskPhoneModal";
import OfferingModal from "./OfferingModal";

export default function HandleSiteLocation() {
  const { siteId, locationId } = useParams();
  const [loaded, setLoaded] = useState(false);
  const [registerMode, setRegisterMode] = useState("mbo");

  const {
    setSelectedSiteId,
    setSelectedLocationId,
    setLocationPreferences,
    loadLocationPreferences,
  } = useFlow();

  const navigate = useNavigate();

  window.addEventListener("message", (event) => {
    if (event.data.type === "customization") {
      const data = event.data.data;
      setLocationPreferences(data);
    }
  });

  useEffect(() => {
    if (siteId && locationId) {
      clearHubSpotState();
    }

    const loadAll = async () => {
      setSelectedSiteId(siteId);
      setSelectedLocationId(locationId);
      try {
        const pref = await loadLocationPreferences(siteId, locationId);
        document.title = `Check-in | ${pref?.locationName || "Flow Network"}`;

        setLoaded(true);
      } catch (error) {
        navigate("/error");
        setLoaded(true);
      }
    };
    if (siteId && locationId) {
      loadAll();

      if (siteId == "30313" || siteId == "228" || siteId == "5734086") {
        setRegisterMode("old");
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "hs-script-loader";
        script.async = true;
        script.defer = true;
        script.src = "//js-na1.hs-scripts.com/8089473.js";
        console.log("loading hubspot", script);
        document.body.appendChild(script);
      }
    }
  }, [siteId, locationId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {loaded && (
        <>
          <Outlet />
          <RegisterModal mode={registerMode} />
          <TermsModal />
          <PlansOfferModal />
          <PopularItemModal />
          <FindClientModal />
          <NewCheckoutModal />
          <ProductListModal />
          <CheckoutGiftcardModal />
          <EventDetailModal />
          <MapResourceModal />
          <EventNotificationModal />
          <AskPhoneModal />
          <OfferingModal />
        </>
      )}
    </>
  );
}
